import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ArticlePopup from '../popupContents/articlePopup';
import React from 'react';
import Modal from '../popupContents/modal';
import ReactDOM from 'react-dom';

class CustomSwal {
	static getCustomSwal() {
		const customSwal = withReactContent(Swal);
		const FullScreenDialog = customSwal.mixin({
			grow              : 'fullscreen',
			background        : '#EEEEEE',
			showCloseButton   : true,
			showConfirmButton : false,
			heightAuto        : false,
			animation         : false,
			customClass       : {
				popup       : 'animated fadeInUp',
				closeButton : 'close-button-class'
			}
		});
		return FullScreenDialog;
	}

	static firePopUpAgain = (article, apisWorking) => {
		const popupContent = (
			<ArticlePopup article={article} apisWorking={apisWorking} firePopUpAgain={this.firePopUpAgain} />
		);
		// if (!window.matchMedia('(max-width: 900px)').matches) {
		//   const FullScreenDialog = CustomSwal.getCustomSwal();
		//   FullScreenDialog.fire({
		//     html: popupContent
		//   }).then(function() {});
		// } else {
		var container = document.getElementById('user_modal');
		if (container.contains(document.getElementById('modal_content'))) {
			container.removeChild(document.getElementById('modal_content'));
		}
		var contentModal = document.createElement('div');
		contentModal.setAttribute('id', 'modal_content');
		container.appendChild(contentModal);
		document.body.classList.add('open_modal');
		// open_modal_app
		document.getElementById('app').classList.add('open_modal_app');
		ReactDOM.render(popupContent, contentModal);
		// }
	};

	static firePopUpVideo = (videoPopup) => {
		if (!window.matchMedia('(max-width: 900px)').matches) {
			const FullScreenDialog = CustomSwal.getCustomSwal();
			FullScreenDialog.fire({
				html : videoPopup
			}).then(function() {});
		}
		else {
			var container = document.getElementById('user_modal');
			var contentModal = document.createElement('div');
			contentModal.setAttribute('id', 'modal_content_video');
			container.appendChild(contentModal);
			document.body.classList.add('open_modal');
			ReactDOM.render(videoPopup, contentModal);
		}
	};

	// static firePopUpAgain = (article, apisWorking) => {
	//   const popupContent = (
	//     <ArticlePopup
	//       article={article}
	//       apisWorking={apisWorking}
	//       firePopUpAgain={this.firePopUpAgain}
	//     />
	//   );
	//   if (window.matchMedia('(max-width: 900px)').matches) {
	//     const FullScreenDialog = CustomSwal.getCustomSwal();
	//     FullScreenDialog.fire({
	//       html: popupContent
	//     }).then(function() {});
	//   } else {
	//     console.log('modal fired ', document.getElementById('modal'));
	//     return <Modal>{true ? popupContent : null}</Modal>;
	//   }
	// };
}

export default CustomSwal;



// WEBPACK FOOTER //
// ./components/popupContents/CustomSwal.js